import React from 'react';

import SearchForumCommentHit from './Comment';
import SearchForumPostHit from './Post';
import type {
  SearchForumHit as Hit,
  SearchForumCommentHit as CommentHit,
  SearchForumPostHit as PostHit,
} from '../../types';

import './style.scss';

export interface SearchForumHitProps {
  hit: Hit;
}

const SearchForumHit: React.FC<SearchForumHitProps> = (props) => {
  const { hit } = props;

  if (hit.entity_type[0] === 'comment') {
    return <SearchForumCommentHit hit={hit as CommentHit} />;
  }

  return <SearchForumPostHit hit={hit as PostHit} />;
};

export default SearchForumHit;
